import { useState } from 'react';

import { reportPostAsAbuse, reportCommentAsAbuse } from '../Services/Api';
import { useNotifications } from '@toolpad/core/useNotifications';
import { notify } from '../Utils/NotificationUtils';

export default (postId: any, commentId: any) => {
  const notifications = useNotifications();
  const [error, setError] = useState<any>(null);
  const [loading, setLoading] = useState(false);

  const createReportForPost = async (data: any) => {
    try {
      setLoading(true);
      const isComment = !!commentId;

      if (isComment) {
        const response = await reportCommentAsAbuse(postId, commentId, data);

        if (!response.ok) {
          notify(notifications, response?.data?.errors[0]?.detail, 'error');
        }

        setLoading(false);

        return response;
      }

      const response = await reportPostAsAbuse(postId, data);

      setLoading(false);

      return response;
    } catch (postError) {
      setError(postError);

      return undefined;
    }
  };

  return { createReportForPost, loading, error };
};
